import ProgressLoader from "@Components/ProgressLoader/ProgressLoader";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/store";

const SearchProgressBar: FC<{ isPollingDone: boolean }> = ({ isPollingDone }) => {
  const restart = useSelector((state: RootState) => state.timer.restartFlag);
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (isPollingDone) {
      setProgress(100);
      const t = setTimeout(() => setVisible(false), 800);
      return () => clearTimeout(t);
    }

    setVisible(true);
    setProgress(0);
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev;
        return prev + (90 - prev) * 0.025; // easing: decelerates as it approaches 90
      });
    }, 100);
    return () => clearInterval(interval);
  }, [isPollingDone, restart]);

  if (!visible) return null;

  return <ProgressLoader head={null} progress={progress} />;
};

export default SearchProgressBar;
